import httpClient from '@/http-client'

export const classAttendance = data => {
    return httpClient
        .get('/api/report/class-attendance-check-lists', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const getTeacher = (params = {}) => {
    return httpClient.get('/api/report/class-attendance-check-lists/get-teachers', { params })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const fetchStudyTime = (Options = {}) => {
    return httpClient
        .get('/api/report/class-attendance-check-lists/study-times', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const getClasslass = (params = {}) => {
    return httpClient
        .get('/api/report/class-attendance-check-lists/get-class-by-teacher', { params }) // 👈 this is important
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const getTerm = (params = {}) => {
    return httpClient
        .get('/api/report/class-attendance-check-lists/get-terms', { params })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export default {
    classAttendance,
    getTeacher,
    fetchStudyTime,
    getClasslass,
    getTerm
}
